if (!customElements.get("offers-drawer")) {
  class OffersDrawer extends SideDrawer {
    constructor() {
      super();

      this.openerSelector = "[data-open-offers]";
      this.closeSelector = ".js-close-drawer";

      this.bindEvents();
      document.querySelector(".js-offers-counter").innerText =
        this.dataset.count;
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.handleClick);
    }

    bindEvents() {
      this.handleClick = this.onClick.bind(this);
      document.addEventListener("click", this.handleClick);
    }

    onClick(evt) {
      const opener = evt.target.closest(this.openerSelector);
      const closer = evt.target.closest(this.closeSelector);

      /* ---------- OPEN ---------- */
      if (opener) {
        evt.preventDefault();

        if (opener.classList.contains("is-open")) {
          this.close();
          opener.classList.remove("is-open");
        } else {
          this.open(opener);
          opener.classList.add("is-open");
        }
        return;
      }

      /* ---------- CLOSE BUTTON ---------- */
      if (closer) {
        evt.preventDefault();
        this.close();
        return;
      }

      /* ---------- OVERLAY CLICK ---------- */
      if (evt.target === this.overlay) {
        this.close();
      }
    }

    open(opener) {
      this.overlay.classList.add("overlay--over-nav", "js-offers-overlay");
      super.open(opener);
    }

    close() {
      document
        .querySelectorAll(this.openerSelector)
        .forEach((btn) => btn.classList.remove("is-open"));

      this.overlay.classList.remove("overlay--over-nav", "js-offers-overlay");
      super.close();
    }
  }

  customElements.define("offers-drawer", OffersDrawer);
}
